import { NotificationManager } from '@atlas/core';

import {
  DEPOSIT_BUTTON_OPENS,
  DEPOSIT_POPUP_NOTIFICATION_ID,
  DEPOSIT_POPUP_NOTIFICATION_TYPE,
} from './constants';

export const shouldOpenDepositPopup = (depositButtonOpens, isPartiallyRegistered) =>
  depositButtonOpens === DEPOSIT_BUTTON_OPENS.POPUP && !isPartiallyRegistered;

export const openDepositPopup = () =>
  NotificationManager.display({
    id: DEPOSIT_POPUP_NOTIFICATION_ID,
    type: DEPOSIT_POPUP_NOTIFICATION_TYPE,
  });
